import { render } from "./MarkDownViewForTrans.vue?vue&type=template&id=ac440bce&scoped=true"
import script from "./MarkDownViewForTrans.vue?vue&type=script&lang=js"
export * from "./MarkDownViewForTrans.vue?vue&type=script&lang=js"

import "./MarkDownViewForTrans.vue?vue&type=style&index=0&id=ac440bce&scoped=true&lang=css"
import "./MarkDownViewForTrans.vue?vue&type=style&index=1&id=ac440bce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac440bce"]])

export default __exports__